import React from "react";
import { RouteComponentProps, useHistory, useLocation } from "react-router-dom";
import {
  PATH_SETTINGS_PAYMENT_METHODS,
  PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD
} from "../../../paths";
import { LayoutFullscreen } from "../../../../../shared/components/LayoutFullscreen";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import { ManagePayoutMethod } from "../../../components/payout/ManagePayoutMethod";

export const RouteManagePayoutMethod: React.FC<RouteComponentProps> = () => {
  const history = useHistory();
  const location = useLocation<{ error?: WSServiceError }>();

  const onBack = () => history.push(PATH_SETTINGS_PAYMENT_METHODS);

  return (
    <LayoutFullscreen
      headTitle="Edit payout methods"
      title="Edit payout methods"
      description="Add a new payout method or set an existing payout method as default"
      onBack={onBack}
    >
      <ManagePayoutMethod
        onSaved={onBack}
        onAddNew={() => {
          history.push(PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD);
        }}
        error={location.state?.error}
      />
    </LayoutFullscreen>
  );
};
